import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventService, ScApiService } from '@sc-ui';
import { texts } from './project-ident.texts';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-project-ident',
  templateUrl: './project-ident.html',
  styleUrl: './project-ident.scss',
})
export class ProjectIdent implements OnChanges, OnDestroy {

  texts = texts;

  @Input()
  project: any;

  batches : any = [];

  demoCandidates: any = [];

  candidates: any = [];

  selectedBatch : any = null;

  selectedStatus = 'all';

  filteredCandidates = [];

  isLoading = true;

  // ?obfuscate hides real candidates for demos and screenshots
  obfuscate = false;

  // in the order of the avatar images, whose subjects are f, m, m, f, f, m, m, f
  private fakeNames = [
    { FirstName: 'Anna', LastName: 'Berger' },
    { FirstName: 'Tobias', LastName: 'Lang' },
    { FirstName: 'Jonas', LastName: 'Keller' },
    { FirstName: 'Nina', LastName: 'Hartmann' },
    { FirstName: 'Laura', LastName: 'Seibert' },
    { FirstName: 'Markus', LastName: 'Dreyer' },
    { FirstName: 'David', LastName: 'Nowak' },
    { FirstName: 'Sophie', LastName: 'Krammer' }
  ];

  private onDestroy = new Subject();

  constructor(private api: ScApiService, private events: EventService, public loc: LocalizationService,
    private route: ActivatedRoute) {

    this.route.queryParams.subscribe((params: any) => this.obfuscate = params.obfuscate != null);
  }

  private obfuscateCandidates(candidates: any) {

    if (!this.obfuscate || !candidates) return candidates;

    candidates.forEach((c, i) => {
      var fake = this.fakeNames[i % this.fakeNames.length];
      c.FirstName = fake.FirstName;
      c.LastName = fake.LastName;
      c.Image = window.location.origin + '/assets/img/avatars/profiles/avatar-' + (i % 8 + 1) + '.jpg';
    });

    return candidates;
  }

  ngOnDestroy() {

    this.onDestroy.next();

  }
  ngOnChanges() {

    this.onDestroy.next();

    if (!this.project) return;

    this.candidates = []
    
    this.selectedStatus = localStorage.getItem('selected_status_' + this.project.Id) ?? 'all';

    this.events
      .channel(`projects/${this.project.Id}/assignments`)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d: any) => {

        console.log(d);

        var candidate = this.candidates.find(c => c.Id == d.Payload?.CandidateId);
        console.log(this.candidates);

        if (candidate) {
          candidate.Assignment.AcceptanceStatus = d.Payload.AcceptanceStatus;
          candidate.Assignment.IsHired = d.Payload.IsHired;
        }


      });

    this.api.get(`projects/${this.project.Id}/batches`).subscribe((d: any) => {

      this.batches = d;

      var savedSelectedBatch = localStorage.getItem('selected_batch_' + this.project.Id);
      if (savedSelectedBatch)
      {
        var s = this.batches.find(b => b.Id == savedSelectedBatch);
        if (s) this.selectedBatch = s;
        this.applyFilter();
      }
    });

    this.api.get(`projects/${this.project.Id}/candidates`).subscribe((d: any) => {

      this.isLoading = false;
      this.candidates = this.obfuscateCandidates(d);
      this.applyFilter();

    });

    this.api.get('projects/' + this.project.Id + '/analysis').subscribe((d: any) => {
      this.isLoading = false;
      this.demoCandidates = this.obfuscateCandidates(d.Profiles);
    });

  }

  applyFilter()
  {
    var filter = (candidate : any ) => {      

      var storageKeyBatch = 'selected_batch_' + this.project.Id;

      if (this.selectedBatch && candidate.BatchId != this.selectedBatch.Id) return false;     
      if (this.selectedStatus == 'accepted' && candidate.Assignment.AcceptanceStatus != 'Accepted') return false;
      if (this.selectedStatus == 'rejected' && candidate.Assignment.AcceptanceStatus != 'Rejected') return false;
      if (this.selectedStatus == 'undecided' && candidate.Assignment.AcceptanceStatus != 'None') return false;

      if (this.selectedBatch)
      {
        localStorage.setItem(storageKeyBatch, this.selectedBatch.Id.toString());
      }
      else
      {
        localStorage.removeItem(storageKeyBatch);
      }
      
      localStorage.setItem('selected_status_' + this.project.Id, this.selectedStatus);

      return true;
    };

    this.filteredCandidates = this.candidates.filter(c => filter(c));

  }
}
